import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class CustomMetricsPopupScriptTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.CUSTOM_METRICS_POPUP_SCRIPT;

	get id(): string {
		return TourId.CUSTOM_METRICS_POPUP_SCRIPT;
	}

	override get keyForPersistantDone(): string {
		return CustomMetricsPopupScriptTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: function () {
					return $('.landing-side--script .scriptLine:eq(0) .script-item:eq(0) > div');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
